function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 15.3c2.17 0 6.5 1.117 6.5 3.333v.834c0 .458-.366.833-.813.833H6.313c-.446 0-.812-.375-.812-.833v-.834c0-2.216 4.33-3.333 6.5-3.333zM6.5 12c.226 0 .475.012.74.036.313.968.911 1.806 1.696 2.415-1.65.443-3.295 1.214-4.222 2.344L4.557 17H.812C.366 17 0 16.625 0 16.167v-.834C0 13.117 4.33 12 6.5 12zm11.003 0c2.17 0 6.5 1.117 6.5 3.333v.834c0 .458-.365.833-.812.833h-3.745l-.157-.205c-.927-1.13-2.571-1.9-4.222-2.344.785-.61 1.384-1.447 1.695-2.415.266-.024.515-.036.741-.036zM12 7c1.934 0 3.5 1.566 3.5 3.5S13.934 14 12 14s-3.5-1.566-3.5-3.5S10.066 7 12 7zM6.5 4c1.422 0 2.645.847 3.193 2.064C8.093 6.897 7 8.571 7 10.5c0 .155.007.308.02.46-.168.027-.343.04-.52.04C4.566 11 3 9.434 3 7.5S4.566 4 6.5 4zm11.003 0c1.934 0 3.5 1.566 3.5 3.5s-1.566 3.5-3.5 3.5c-.177 0-.352-.013-.52-.04.013-.152.02-.305.02-.46 0-1.929-1.092-3.603-2.693-4.436C14.858 4.847 16.081 4 17.503 4z"
});

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#c4c4c4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.d71455c4.svg";
export { ForwardRef as ReactComponent };